document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth >= 990) {
    const detailsItems = document.querySelectorAll('header details');
    console.log("Found", detailsItems.length, "<details> items");

    detailsItems.forEach(function(detail) {
      detail.addEventListener('mouseenter', function() {
        detail.setAttribute('open', 'true');
        console.log("Opening menu");
      });

      detail.addEventListener('mouseleave', function() {
        detail.removeAttribute('open');
        console.log("Closing menu");
      });
    });
  }
});

